import { render, staticRenderFns } from "./DocumentsRoot.vue?vue&type=template&id=27e8f330"
import script from "./DocumentsRoot.vue?vue&type=script&lang=js"
export * from "./DocumentsRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e8f330')) {
      api.createRecord('27e8f330', component.options)
    } else {
      api.reload('27e8f330', component.options)
    }
    module.hot.accept("./DocumentsRoot.vue?vue&type=template&id=27e8f330", function () {
      api.rerender('27e8f330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/DocumentsRoot.vue"
export default component.exports